

































































































import CtrlAddBtn from '@/components/common/control/CtrlAddBtn.vue';
import CtrlClearBtn from '@/components/common/control/CtrlClearBtn.vue';
import CtrlDatePicker from '@/components/common/control/CtrlDatePicker.vue';
import CtrlMessageDialog from '@/components/common/control/CtrlMessageDialog.vue';
import CtrlResetBtn from '@/components/common/control/CtrlResetBtn.vue';
import CtrlHimmoku from '@/components/common/search/CtrlHimmoku.vue';
import G_080_KojoDekidakaEntry_ChildHeaderInput from '@/components/G_kaigai/G_080_KojoDekidakaEntry_ChildHeaderInput.vue';
import G_080_KojoDekidakaEntry_Table from '@/components/G_kaigai/G_080_KojoDekidakaEntry_Table.vue';
import { OutStatus, ShoriKb, TaishoFlg, UmuFlg } from '@/constants/constants';
import { dateStrToNum } from '@/utils/utils';
import moment from 'moment';
import Vue from 'vue';
import { mapGetters } from 'vuex';

export default Vue.extend<any, any, any, any>({
  name: 'G_080_KojoDekidakaEntry',
  components: {
    CtrlMessageDialog,
    CtrlResetBtn,
    CtrlClearBtn,
    CtrlAddBtn,
    CtrlDatePicker,
    CtrlHimmoku,
    G_080_KojoDekidakaEntry_ChildHeaderInput,
    G_080_KojoDekidakaEntry_Table,
  },
  data: () => ({
    UmuFlg,
    TaishoFlg,

    seizoYmdF: '',
    seizoYmdT: '',
    himmokuCd: 0,
    search: '',
    items: [],

    ShoriKb,
    shoriKb: ShoriKb.ADD,
    childHeaderInputItem: {},
    childHeaderInputShow: false,
    messageShow: false,
    messageId: '',
    messageTextParam: [],
    isClearTable: false,
  }),
  computed: {
    ...mapGetters({
      userInfo: 'common/userInfo',
    }),
    genzaiYmd() {
      return this.userInfo && this.userInfo.onlineData
        ? this.userInfo.onlineData.genzaiYmd
        : 0;
    },
  },
  methods: {
    initValues() {
      this.seizoYmdF = moment(this.genzaiYmd, 'YYYYMMDD')
        .date(1)
        .format('YYYY-MM-DD');
      this.seizoYmdT = moment(this.genzaiYmd, 'YYYYMMDD').format('YYYY-MM-DD');
      this.himmokuCd = 0;
      this.search = '';
    },
    async handleReset() {
      if (await this.checkValidate()) {
        this.items = [];
        this.getData();
      }
    },
    handlClear() {
      this.initValues();
      this.items = [];
    },
    handleOkMessage() {
      if (this.messageId == 'KI_W123') {
        window.location.href = '/';
      }
      this.messageId = '';
      this.messageTextParam = [];
      this.messageShow = false;

      if (this.isClearTable) {
        this.isClearTable = false;
        this.items = [];
      }
    },
    handleAdd() {
      this.childHeaderInputItem = {
        kyoryokuKojoCd: this.userInfo.shiiresakiCd,
        seizoYmd: this.genzaiYmd,
      };
      this.shoriKb = ShoriKb.ADD;
      this.childHeaderInputShow = true;
    },
    handleInfo(item: any) {
      this.childHeaderInputItem = {
        ...item,
        kyoryokuKojoCd: this.userInfo.shiiresakiCd,
      };
      this.shoriKb = ShoriKb.REFER;
      this.childHeaderInputShow = true;
    },
    handleEdit(item: any) {
      this.childHeaderInputItem = {
        ...item,
        kyoryokuKojoCd: this.userInfo.shiiresakiCd,
      };
      this.shoriKb = ShoriKb.UPD;
      this.childHeaderInputShow = true;
    },
    handleChildHeaderInputHide(reload: boolean) {
      if (reload) {
        this.getData();
      }
    },
    async callbackOkHimmoku(item: any) {
      if (item && item.himmokuCd) {
        this.himmokuCd = item.himmokuCd;
      } else {
        this.himmokuCd = 0;
      }
    },
    async checkValidate() {
      await new Promise((resolve) => setTimeout(resolve, 300));
      this.$refs.form.validate();

      if (!dateStrToNum(this.seizoYmdF) || !dateStrToNum(this.seizoYmdT)) {
        this.messageId = 'KI_W100';
        this.messageTextParam = ['製造日'];
        this.messageShow = true;
        return;
      }
      if (
        this.seizoYmdF &&
        this.seizoYmdT &&
        dateStrToNum(this.seizoYmdF) > dateStrToNum(this.seizoYmdT)
      ) {
        this.messageId = 'KI_W101';
        this.messageTextParam = ['製造日'];
        this.messageShow = true;
        return;
      }
      if (!this.$refs.form.validate()) {
        this.messageId = 'KI_W121';
        this.messageTextParam = [];
        this.messageShow = true;
        return;
      }
      return true;
    },
    async getData() {
      this.$store.dispatch('common/setIsLoading', true);
      const params = {
        seizoYmdF: dateStrToNum(this.seizoYmdF),
        seizoYmdT: dateStrToNum(this.seizoYmdT),
        kyoryokuKojoCd: this.userInfo.shiiresakiCd,
        himmokuCd: this.himmokuCd,
      };
      const res = await this.$store.dispatch(
        'g080/getKojoDekidakaEntry',
        params
      );
      this.$store.dispatch('common/setIsLoading', false);

      if (
        res &&
        res.status == 200 &&
        res.data &&
        res.data.error &&
        res.data.error.outStatus &&
        res.data.error.outStatus != OutStatus.NORMAL
      ) {
        const { error } = res.data;
        this.messageShow = true;
        this.messageId = error.messageID;
        this.messageTextParam = error.messageArgs;
        this.isClearTable = true;
        return;
      }

      this.items = res.data.responseData ? res.data.responseData : [];
    },
  },
  created() {
    if (!this.userInfo.shiiresakiCd) {
      this.messageId = 'KI_W123';
      this.messageTextParam = ['利用者マスタの仕入先が未設定の', '実行'];
      this.messageShow = true;
      return;
    }
    this.initValues();
  },
});
